const TextParser = {

  parse: (text, removeEmptyEntries = true) => {
    if (!text) {
      return []
    }
    const lines = text.split(/\n|\r/g)
    const result = []
    for (let line of lines) {
      line = line.trim()
      if (line.length || !removeEmptyEntries) {
        result.push(line.trim())
      }
    }
    return result
  }

}

export default TextParser



// WEBPACK FOOTER //
// ./src/schedule/common/modules/common/TextParser.js